import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const TableBodyRows = ({ id, columns, rows }) => {
  return (
    <TableBody key={`table-body-rows-${id}`}>
      {rows.map((row, index) => (
        <TableRow key={`table-body-row-${id}-${row._id}-index-${index}`}>
          {columns.map((column) => (
            <TableCell
              key={`table-body-row-cell-${id}-${column.key}-${row._id}-index-${index}`}
              align={column.align ? column.align : 'left'}
              className={column.className ?? ''}
              style={column.stickyLeft != null ? { left: column.stickyLeft } : undefined}
            >
              {row[column.key]}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

export default TableBodyRows;
